export default function Metric({ icon, label, value, unit, tone, note, onClick }) {
  return (
    <div
      className={`metric ${onClick ? "metric-clickable" : ""}`}
      data-testid={`metric-${label.toLowerCase().replaceAll(" ", "-")}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className={`metric-icon ${tone}`}>{icon}</div>
      <div>
        <span>{label}</span>
        <strong>
          {value}
          <em>{unit}</em>
        </strong>
        {note && <small className="metric-note">{note}</small>}
      </div>
    </div>
  );
}
